import { AvailableTeamMembersEnum, TeamMember } from '@/__generated__/graphql';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/shadcn/table';
import { cn } from '@/lib/utils';
import SettingsTabTitle from '@/components/compound-components/settings/settings-tab-title';
import { FragmentType, gql, useFragment } from '@/__generated__';

const formatDateToUTC = (dateString: string) => {
  const date = new Date(dateString);
  const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  return utcDate.toDateString();
};

const TeamMemberSectionFragment = gql(`
  fragment TeamMemberSectionFragment on Organization {
    teamMembers {
      name
      status
      start
      end
    }
  }
`);

const TEAM_MEMBERS_COLOR = {
  [AvailableTeamMembersEnum.Maggie]: 'maggie',
  [AvailableTeamMembersEnum.Grant]: 'grant',
};

export default function TeamMemberSection({
  teamMembers,
}: {
  // teamMembers: TeamMember[];
  teamMembers: FragmentType<typeof TeamMemberSectionFragment>;
}) {
  const teamMembersFragment = useFragment(
    TeamMemberSectionFragment,
    teamMembers
  );

  return (
    <div className='grid'>
      <SettingsTabTitle title='Team Members Info' />
      <Table className='min-w-[600px]'>
        <TableHeader>
          <TableRow>
            <TableHead>Name</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Start</TableHead>
            <TableHead>End</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {teamMembersFragment?.teamMembers?.map((row: Partial<TeamMember>) => (
            <TableRow key={row.name}>
              {row.name && (
                <TableCell
                  className={cn(`text-${TEAM_MEMBERS_COLOR[row.name]}`)}
                >
                  {row.name}
                </TableCell>
              )}
              <TableCell>{row.status}</TableCell>
              <TableCell>
                {row.start ? formatDateToUTC(row.start) : ''}
              </TableCell>
              <TableCell>{row.end ? formatDateToUTC(row.end) : ''}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
